import React from 'react';
import { connect } from 'react-redux';

import { KYC_MODAL_ERROR_MISSING_DATA } from '../../../services/kyc/constants';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

const KycStepError = ({ i18n, errorType }) => {
    return (
        <div>
            <h3 className="banner error">{i18n.TITLE}</h3>
            <div className="body">
                <p>
                    {errorType === KYC_MODAL_ERROR_MISSING_DATA
                        ? convertHtmlToReactDomWithParams(i18n.TEXT_1_MISSING_DATA)
                        : convertHtmlToReactDomWithParams(i18n.TEXT_1_VERIFICATION_FAILED)}
                </p>
                <p className="italic">{i18n.TEXT_2}</p>
                <p>{i18n.TEXT_3}</p>
                <p>{i18n.TEXT_4}</p>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.FRAUD.KYC_MODAL.STEP_ERROR,
        kycWidgetLink: state.kyc.widgetLink
    };
};

export default connect(mapStateToProps)(KycStepError);



// WEBPACK FOOTER //
// ./src/components/fraud/kyc/KycStepError.js